<script>
   /*****************************************************************/
   /* DFPlot                                                        */
   /* --------------------                                          */
   /* shows plot with number of degrees of freedom vs number of PCs */
   /*****************************************************************/

   import { Axes, XAxis, YAxis, Box, Lines, Legend, Segments, Points } from 'svelte-plots-basic/2d';
   import { PNG_WIDTH, PNG_HEIGHT, PNG_RES, MARGINS } from './Defaults.js';

   export let params;                     // JSON with main plot parameters
   export let plotseries;                 // JSON with plot series
   export let ncomp = 1;                  // number of components selected by user

   export let fileName = 'plot-dof';
   export let pngWidth = PNG_WIDTH;
   export let pngHeight = PNG_HEIGHT;
   export let pngRes = PNG_RES;

   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // constant plot parameters
   const showGrid = true;                  // logical, show grid or not
   const xLabel = 'Number of PCs';
   const yLabel = 'Degrees of freedom, Nu';
   const title = 'DoF plot';

   // colors for series
   const COLORS = ['#2679B2', '#D22C2F']; // Nh, Nq

   // local copies of plot parameters
   let item = 'both';

   // reactive checks of local copies of plot parameters
   $: if (params && params.item && params.item !== item) item = params.item;

   let legendItems = [];
   $: if (item) {
      legendItems = [];
      if (item === 'Nh' || item === 'both')
         legendItems.push({'label': 'Nh', 'borderColor': COLORS[0], 'marker': 1, 'borderWidth': 2});
      if (item === 'Nq' || item === 'both')
         legendItems.push({'label': 'Nq', 'borderColor': COLORS[1], 'marker': 1, 'borderWidth': 2});
   } else {
      legendItems = null;
   };

   let xMax, yMax;
   $: if (plotseries) {
      xMax = plotseries.ncomp;
      yMax = {
         'both': 1.2 * Math.max(plotseries.NhMax, plotseries.NqMax),
         'Nh': 1.2 * plotseries.NhMax,
         'Nq': 1.2 * plotseries.NqMax
      };
   } else {
      xMax = null;
      yMax = null;
   }
</script>

{#if params && plotseries }
<Axes {title} {xLabel} {yLabel}
   downloadLinks="hover"
   margins={MARGINS}
   limX={[0.5, xMax + 0.5]}
   limY={[-1, yMax[item]]}
   {fileName} {pngWidth} {pngHeight} {pngRes}
>

   <Segments xStart={[ncomp]} xEnd={[ncomp]} yStart={[-1]} yEnd={[yMax[item]]} lineColor='#00000040' />

   {#if item === 'Nh' || item === 'both'}
   <Lines xValues={plotseries.x} yValues={plotseries.Nh} lineWidth={1.5} lineColor={COLORS[0]} />
   <Points xValues={plotseries.x} yValues={plotseries.Nh} borderWidth={1.5} faceColor='#fff' borderColor={COLORS[0]}/>
   <Points
      xValues={[plotseries.x[ncomp - 1]]}
      yValues={[plotseries.Nh[ncomp - 1]]}
      markerSize={1.5}
      borderWidth={1.5}
      faceColor={COLORS[0]}
      borderColor='#a0a0a0'
   />
   {/if}

   {#if item === 'Nq' || item === 'both'}
   <Lines xValues={plotseries.x} yValues={plotseries.Nq} lineWidth={1.5} lineColor={COLORS[1]} />
   <Points xValues={plotseries.x} yValues={plotseries.Nq} borderWidth={1.5} faceColor='#fff' borderColor={COLORS[1]}/>
   <Points
      xValues={[plotseries.x[ncomp - 1]]}
      yValues={[plotseries.Nq[ncomp - 1]]}
      markerSize={1.5}
      borderWidth={1.5}
      faceColor={COLORS[1]}
      borderColor='#a0a0a0'
   />
   {/if}

   <Legend items={legendItems} />
   <XAxis {showGrid} slot="xaxis" whole={true}/>
   <YAxis {showGrid} slot="yaxis" />
   <Box slot="box" />
</Axes>
{/if}